import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { useHistory } from 'react-router';
// firebase
import { db, FIREBASE_DB_ROOT, uid } from 'common/firebase';
// icon
import iconBookFinished from 'assets/images/timeline-images/finished-book.svg';
// constant
import { getUser } from 'redux/selectors';
import { getDifferenceDateStr } from 'common/utils/dateUtils';
import moment from 'moment';
import { URLS } from 'common/urls';

const EmailImportReadyNotification = ({
    data,
    user: authUser,
    notificationKey,
    fullView
}) => {
    const { read, created_at, journal_id } = data;
    const history = useHistory();

    const showNotification = () => {
        // update the notification read
        db.ref(
            `${FIREBASE_DB_ROOT}${uid}/${authUser.id}/${notificationKey}`
        ).set({
            ...data,
            read: true
        });

        if (journal_id) {
            history.push(`${URLS.JOURNAL}${journal_id}`);
        } else {
            history.push(URLS.JOURNAL);
        }
    };
    return (
        <li
            className="alert-card__item alert-card__item--buttons"
            onClick={showNotification}
        >
            <div className="alert-card__img">
                <img src={iconBookFinished} alt="email-import-finished" />
            </div>
            <div className="alert-card__content">
                Your Email Import is complete! You can now check your journal.
            </div>
            {!read && (
                <div className="notification-active-bullet-dropdown"></div>
            )}
            {fullView && created_at && (
                <p className="notification-timestamp ml-auto">
                    {getDifferenceDateStr(
                        moment.utc(created_at).local(),
                        moment(new Date())
                    )}
                </p>
            )}
        </li>
    );
};

const state = createStructuredSelector({
    user: getUser
});
export default connect(state)(EmailImportReadyNotification);
